import { useEffect, useRef } from 'react';
import { useRevalidator } from '@remix-run/react';
import { syncCustomerPricing } from '~/utils/customer-login-sync';

/** Reconcile production login identity with QA and QA2 before refreshing member prices. */
export function useCustomerPricingSync() {
  const { revalidate } = useRevalidator();
  const revalidateRef = useRef(revalidate);
  revalidateRef.current = revalidate;
  useEffect(() => {
    let active = true;
    let generation = 0;
    const refresh = async () => {
      const revision = ++generation;
      // Registration owns syncing after its Alpine binding has been saved.
      if (window.location.pathname === '/register') return;
      const token = localStorage.getItem('access_token');
      if (!token) return;
      const ready = await syncCustomerPricing(token);
      if (!active || generation !== revision || localStorage.getItem('access_token') !== token)
        return;
      if (ready) {
        window.dispatchEvent(new Event('pricing:ready'));
        revalidateRef.current();
      }
    };
    void refresh();
    window.addEventListener('user:login', refresh);
    window.addEventListener('auth:refreshed', refresh);
    window.addEventListener('user:logout', refresh);
    return () => {
      active = false;
      window.removeEventListener('user:login', refresh);
      window.removeEventListener('auth:refreshed', refresh);
      window.removeEventListener('user:logout', refresh);
    };
  }, []);
}
